module.exports = __webpack_public_path__ + "static/media/SWAP_LIGHT.84b57a6d.png";